import { Text } from '@capsicum/common-web';
import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.xxsmall};
`;

export const Title = styled(Text)`
	text-transform: uppercase;
`;

export const TokenCards = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.spacings.xsmall};
`;
